import { useCallback } from 'react';
import type { ResourceType } from '@cotera/api';
import type { ItemAction } from '../list/resource-list-view-types';
import { ResourceMenuItem } from '../list/resource-item-actions';
import { useFavorites } from './use-favorites';
import { useToggleFavorite } from './use-toggle-favorite';

/**
 * Builds the "Favorite" / "Unfavorite" entry for one row's menu.
 *
 * A factory rather than a per-row hook: the lists build every row's menu inside
 * a `map`, where a hook cannot be called. One subscription to the favorites
 * state covers the whole list.
 */
export function useFavoriteMenuItem(): (
  type: ResourceType,
  id: string
) => ItemAction {
  const { isFavorite } = useFavorites();
  const toggleFavorite = useToggleFavorite();
  return useCallback(
    (type: ResourceType, id: string): ItemAction => {
      const favorited = isFavorite(type, id);
      return ResourceMenuItem.favorite(favorited, () =>
        toggleFavorite(type, id)
      );
    },
    [isFavorite, toggleFavorite]
  );
}
